import { Role } from '../types/role.enum';

export const ADMIN_GROUP = [
  Role.ADMIN, Role.SUPERADMIN
];

export const SUPER_ADMIN_GROUP = [ Role.SUPERADMIN ];

export const LISTINGS_GROUP = [
  Role.SALES_SUPPORT, Role.LISTINGS, Role.RES_INTERNAL_BROKER,
  Role.COM_INTERNAL_BROKER,
  Role.SALES_DIRECTOR,
  ...ADMIN_GROUP
];

export const QC_GROUP = [ ...LISTINGS_GROUP ];

export const INTERNAL_GROUP = [
  Role.RES_INTERNAL_BROKER, Role.COM_INTERNAL_BROKER,
  Role.SALES_DIRECTOR,
  Role.CONTENT_PROVIDER, Role.LISTINGS,
  Role.MARKETING, Role.SALES_SUPPORT, Role.BROKER_MANAGER,
  Role.ACCOUNTING,
  ...ADMIN_GROUP
];

export const LOGS_ADMIN_GROUP = [
  Role.BROKER_MANAGER, Role.LISTINGS,
  Role.SALES_SUPPORT, Role.ACCOUNTING,
  ...ADMIN_GROUP
];

export const BUSINESS_GROUP = [
  Role.RES_ASSOCIATE_BROKER, Role.COM_ASSOCIATE_BROKER, // Old, replaced with ROLE_PARTNER_BROKER
  Role.PARTNER_BROKER,
  Role.RES_INTERNAL_BROKER, Role.COM_INTERNAL_BROKER, // Old, replaced with ROLE_SALES_DIRECTOR
  Role.SALES_DIRECTOR,
  Role.BROKER_MANAGER, Role.ACCOUNT_MANAGER,
  Role.ACCOUNTING,
  ...ADMIN_GROUP
];

export const BROKER_MANAGEMENT_GROUP = [
  Role.BROKER_MANAGER,
  ...ADMIN_GROUP
];

export const INVOICING_GROUP = [
  Role.BROKER_COORDINATOR,
  Role.SALES_DIRECTOR,
  Role.SALES_LEASING_EXECUTIVE,
  Role.ACCOUNTING,
  ...ADMIN_GROUP
];

export const MAGAZINE_GROUP = [
  Role.MARKETING, Role.CONTENT_PROVIDER,
  ...ADMIN_GROUP
];
